"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var pinata_1 = require("@snoam/pinata");
var City = (function (_super) {
    __extends(City, _super);
    function City(props) {
        var _this = _super.call(this, props) || this;
        _this.onCityChange = function (__event) {
            var value = __event.target.value;
            if (value !== "") {
                if (value.length > 30) {
                    _this.setState({ errorMessage: 'Maks 30 tegn', valid: false });
                    return;
                }
                else {
                    _this.setState({ errorMessage: '', valid: true });
                    _this.props.updateCity(value);
                }
            }
            else {
                _this.setState({ errorMessage: 'Fyll inn', valid: false });
                return;
            }
        };
        _this.state = {
            value: props.cityName,
            valid: !!props.cityName,
            errorMessage: ''
        };
        return _this;
    }
    City.prototype.UNSAFE_componentWillReceiveProps = function (nextProps, nextContext) {
        var prevCityName = nextProps.cityName;
        var nextCityName = this.props.cityName;
        if (prevCityName !== nextCityName) {
            this.setState({
                value: nextCityName,
                valid: nextCityName && nextCityName.length > 0
            });
        }
    };
    City.prototype.componentDidUpdate = function (prevProps) {
        var prevCityName = prevProps.cityName;
        var nextCityName = this.props.cityName;
        if (prevCityName !== nextCityName) {
            this.setState({
                value: nextCityName,
                valid: nextCityName && nextCityName.length > 0
            });
        }
    };
    City.prototype.render = function () {
        var _this = this;
        var _a = this.state, value = _a.value, valid = _a.valid, errorMessage = _a.errorMessage;
        var _b = this.props, clearable = _b.clearable, disabled = _b.disabled, showErrors = _b.showErrors;
        return (React.createElement(pinata_1.Input, { autoComplete: "false", onChange: function (e) { return _this.onCityChange(e); }, type: 'text', errorMsg: errorMessage, validMsg: showErrors && valid, label: 'Poststed', value: value, clearable: clearable, disabled: disabled }));
    };
    City.defaultProps = {
        cityName: ''
    };
    return City;
}(React.PureComponent));
exports.default = City;
//# sourceMappingURL=City.js.map